<template>
  <div class="ui grid centered" :columns="columns">
    <div class="ui grid column stretched" id="ddd" v-for="size in sizes" :key="size.id">
      <div class="ui segment"  v-if="size.empty>0" compact :id="size.id" @click="selectItem(size)">
        <a class ="floating ui grey label" >{{ size.empty }}</a>
        <b v-if="size.id.length == 1">&nbsp;{{ size.id }}&nbsp;</b>
        <b v-if="size.id.length > 1">{{ size.id }}</b>
        <b>{{ size.dim }}</b>
      </div>

      <div class="ui segment disabled" v-else compact>
        <a class ="floating ui grey label" >{{ size.empty }}</a>
        <b v-if="size.id.length == 1">&nbsp;{{ size.id }}&nbsp;</b>
        <b v-if="size.id.length > 1">{{ size.id }}</b>
        <b>{{ size.dim }}</b>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['theSizes', 'defaultSelected'],
  data() {
    return {
      columns: null,
      sizes: [],
      selected: null
    }
  },
  mounted() {
    this.initializeComponent(this.theSizes);
  },
  updated() {
    if (this.defaultSelected) {
      this.selectItem(this.defaultSelected);
    }
  },
  methods: {
    initializeComponent() {
      this.columns = this.theSizes.length;
      this.sizes = [... this.theSizes];
    },
    selectItem(theItem) {
      if (theItem.id === this.selected) return;

      let elems = document.getElementsByClassName('segment')
      for (var i = 0; i < elems.length; i++) {
        elems[i].classList.remove('tertiary');
      }

      document.getElementById(theItem.id).classList.add('tertiary');

      this.selected = theItem.id;
      this.$emit('on-size-selected', theItem);
    }
  }
}
</script>
<style>
b {
  font-weight: unset!important;
}

#ddd {
  width: auto;
  text-align: center;
}

.ui.grid {
  width: 100%;
  padding: 0!important;
}

.ui.grid.column {
  padding: 0.7rem!important;
}

.ui.segment.tertiary {
  font-weight: bold;
  background: #00f9a9!important;
}
</style>